module.exports = __webpack_public_path__ + "static/media/undraw_mail_2_tqip.e86d6a56.png";